import type { NotificationDtoPagedResult } from '../types';

// Two different tenants on purpose — the feed is user-global, so mock mode
// must exercise the cross-tenant routing/display path (org indicator, org
// switch on click) rather than only ever showing a single organization.
export const notificationsMock: NotificationDtoPagedResult = {
  items: [
    {
      id: 'notif-1',
      type: 'task_assigned',
      title: 'Nueva tarea asignada',
      message: 'Carlos López te asignó la tarea "Revisar propuesta de diseño"',
      entityId: 'task-101',
      entityType: 'Task',
      actorId: 'user-2',
      recipientId: 'user-1',
      isRead: false,
      readAt: null,
      createdAt: '2026-06-04T10:30:00Z',
      tenantId: 'tenant-1',
      tenantName: 'Innovaforce',
      tenantAvatarUrl: null,
    },
    {
      id: 'notif-2',
      type: 'task_comment_added',
      title: 'Nuevo comentario',
      message: 'Ana García comentó en "Planificación del sprint Q3"',
      entityId: 'task-102',
      entityType: 'Task',
      actorId: 'user-3',
      recipientId: 'user-1',
      isRead: false,
      readAt: null,
      createdAt: '2026-06-04T09:15:00Z',
      tenantId: 'tenant-2',
      tenantName: 'Acme Corp',
      tenantAvatarUrl: null,
    },
    {
      id: 'notif-3',
      type: 'attachment_uploaded',
      title: 'Adjunto subido',
      message: 'Luis Méndez subió un archivo a "Rediseño de portal"',
      entityId: 'task-55',
      entityType: 'Task',
      actorId: 'user-4',
      recipientId: 'user-1',
      isRead: true,
      readAt: '2026-06-03T14:00:00Z',
      createdAt: '2026-06-03T13:45:00Z',
      tenantId: 'tenant-1',
      tenantName: 'Innovaforce',
      tenantAvatarUrl: null,
    },
    {
      id: 'notif-4',
      type: 'task_completed',
      title: 'Tarea completada',
      message: 'María Torres marcó como completada "Configuración de CI/CD"',
      entityId: 'task-99',
      entityType: 'Task',
      actorId: 'user-5',
      recipientId: 'user-1',
      isRead: true,
      readAt: '2026-06-03T11:00:00Z',
      createdAt: '2026-06-03T10:55:00Z',
      tenantId: 'tenant-2',
      tenantName: 'Acme Corp',
      tenantAvatarUrl: null,
    },
  ],
  page: 1,
  pageSize: 20,
  totalCount: 4,
  totalPages: 1,
  hasPreviousPage: false,
  hasNextPage: false,
  firstItemOnPage: 1,
  lastItemOnPage: 4,
};

export const notificationsUnreadMock: NotificationDtoPagedResult = {
  ...notificationsMock,
  items: notificationsMock.items?.filter((n) => !n.isRead) ?? [],
  totalCount: 2,
};
